import { ElementType } from 'react';

import {
  AttachmentIcon,
  BarIcon,
  BigSmileIcon,
  BookIcon,
  BrushIcon,
  BulbIcon,
  CalendarIcon,
  ChartIcon,
  ChartLineIcon,
  ChartPieIcon,
  ChatIcon,
  CompassIcon,
  FileIcon,
  GlobeIcon,
  HeadphonesIcon,
  HeartIcon,
  HourglassIcon,
  MailIcon,
  MegaphoneIcon,
  MessageIcon,
  MicrophoneIcon,
  PaperplaneIcon,
  PhoneIcon,
  ReceiptIcon,
  SadIcon,
  SearchIcon,
  SmileIcon,
  SpeedmeterIcon,
  TargetIcon,
  TimeClockIcon,
  TreeIcon,
  UserIcon,
  UsersIcon,
} from '@/assets/icons';
import { IconName } from '@/components/atoms/Icon/types';

type Icon = {
  categoryName: string;
  icons: {
    name: IconName;
    icon: ElementType;
  }[];
};

export const CATEGORY_ICONS: Icon[] = [
  {
    categoryName: 'iconPickerCategoryPopup.categories.performance',
    icons: [
      {
        name: 'chart',
        icon: ChartIcon,
      },
      {
        name: 'bar',
        icon: BarIcon,
      },
      {
        name: 'chart-line',
        icon: ChartLineIcon,
      },
      {
        name: 'chart-pie',
        icon: ChartPieIcon,
      },
      {
        name: 'target',
        icon: TargetIcon,
      },
      {
        name: 'attachment',
        icon: AttachmentIcon,
      },
      {
        name: 'calendar',
        icon: CalendarIcon,
      },
      {
        name: 'hourglass',
        icon: HourglassIcon,
      },
      {
        name: 'speedmeter',
        icon: SpeedmeterIcon,
      },
      {
        name: 'time-clock',
        icon: TimeClockIcon,
      },
    ],
  },
  {
    categoryName: 'iconPickerCategoryPopup.categories.communication',
    icons: [
      {
        name: 'message',
        icon: MessageIcon,
      },
      {
        name: 'chat',
        icon: ChatIcon,
      },
      {
        name: 'paperplane',
        icon: PaperplaneIcon,
      },
      {
        name: 'receipt',
        icon: ReceiptIcon,
      },
      {
        name: 'mail',
        icon: MailIcon,
      },
      {
        name: 'megaphone',
        icon: MegaphoneIcon,
      },
      {
        name: 'phone-call',
        icon: PhoneIcon,
      },
      {
        name: 'mic',
        icon: MicrophoneIcon,
      },
      {
        name: 'headphones',
        icon: HeadphonesIcon,
      },
    ],
  },
  {
    categoryName: 'iconPickerCategoryPopup.categories.teamCulture',
    icons: [
      {
        name: 'users',
        icon: UsersIcon,
      },
      {
        name: 'user',
        icon: UserIcon,
      },
      {
        name: 'globe',
        icon: GlobeIcon,
      },
      {
        name: 'emoji-big-smile',
        icon: BigSmileIcon,
      },
      {
        name: 'emoji-smile',
        icon: SmileIcon,
      },
      {
        name: 'emoji-sad',
        icon: SadIcon,
      },
      {
        name: 'heart',
        icon: HeartIcon,
      },
      {
        name: 'tree',
        icon: TreeIcon,
      },
    ],
  },
  {
    categoryName: 'iconPickerCategoryPopup.categories.learning',
    icons: [
      {
        name: 'book',
        icon: BookIcon,
      },
      {
        name: 'file',
        icon: FileIcon,
      },
      {
        name: 'search',
        icon: SearchIcon,
      },
      {
        name: 'brush',
        icon: BrushIcon,
      },
      {
        name: 'compass',
        icon: CompassIcon,
      },
      {
        name: 'bulb',
        icon: BulbIcon,
      },
    ],
  },
];
